export const getVersion = () => {
    return '1.2';
};
